export default {
      id: "ellipsis-vertical-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "mysource_files/sprite-map.svg#ellipsis-vertical",
      toString: function () {
        return this.url;
      }
    }